export const CAMPAIGN_TYPES = {
  ONGOING: 'ongoing',
  ONE_OFF: 'one_off',
};

export const API_CAMPAIGN_MESSAGE_CHARACTER_LIMIT = 4096;

export const WHATSAPP_EVOLUTION_CAMPAIGN_MESSAGE_CHARACTER_LIMIT = 4096;
